import React from 'react';
import PropTypes from 'prop-types';
import Search from 'components/widgets/Search';
import { makeStyles } from '@material-ui/core/styles';

// Style
import QueriesBaseLayoutStyles from 'styles/modules/queries/QueriesBaseLayoutStyles';

const useStyles = makeStyles((theme) => QueriesBaseLayoutStyles.childList(theme));

const TableList = ({
    data,
    selected,
    action,
    actionFilter,
}) => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div className={classes.label}>
                Tables
            </div>
            <div className={classes.boxSearch}>
                <Search fullWidth onKeyDown={actionFilter} />
            </div>
            <div className={classes.list}>
                {data.map((table, index) => (
                    <div
                        className={selected === table ? classes.listItemSelected : classes.listItem}
                        onClick={action}
                        key={index}
                    >
                        {table}
                    </div>
                ))}
            </div>
        </div>
    );
};

TableList.defaultProps = {
    data: [],
    selected: '',
};

TableList.propTypes = {
    data: PropTypes.array,
    selected: PropTypes.string,
    action: PropTypes.func.isRequired,
    actionFilter: PropTypes.func.isRequired,
};

export default TableList;
